<div class="container-md text-center">
  <div class="row">
    <div class="col-12 d-flex justify-content-end mb-2">
      <button type="button" class="btn btn-primary" (click)="add()" [disabled]="this.getIsNew()">Add</button>
    </div>
    <div class="table-responsive">
      <table class="table table-xl table-striped table-bordered">
        <thead>
          <tr>
            <th scope="col" *ngFor="let col of this.columns"
              [style.display]="!this.getIsDisplay(col.field)?'none':null">
              <!-- class="{{ col.th_class_name }}" -->
              {{ col.header }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of data">
            <td *ngFor="let col of this.columns" [attr.scope]="getIsKey(col.field) ? 'row' : null"
              [style.display]="!this.getIsDisplay(col.field)?'none':null">
              <!-- <span *ngIf="!isCurrentEdit(row)">
                {{ row[col.field] }}
              </span> -->
              <span *ngIf="!getIsEdit(col.field)">
                {{ row[col.field] }}
              </span>

              <span *ngIf="getIsEdit(col.field)">
                <input *ngIf="isText(col)" [(ngModel)]="row[col.field]" type="text" [disabled]="!isCurrentEdit(row)" />
                <textarea id="autoresizer" (keydown)="this.autoresize_textarea($event)" class="min-width-150px"
                  *ngIf="isTextArea(col)" [(ngModel)]="row[col.field]" [disabled]="!isCurrentEdit(row)"></textarea>
                <select *ngIf="isDropdown(col)" [(ngModel)]="row[col.field]" [disabled]="!isCurrentEdit(row)">
                  <option value="">Select</option>
                  <option *ngFor="let data of col.data" [value]="data.value">
                    {{ data.label }}
                  </option>
                </select>
              </span>

              <span *ngIf="isEditColumn(col.field)">
                <div class="btn-group" role="group" aria-label="Basic example">
                  <button type="button" *ngIf="!isCurrentEdit(row)" class="btn btn-warning btn-sm" (click)="edit(row)">
                    <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                  </button>

                  <button type="button" *ngIf="!isCurrentEdit(row)" class="btn btn-danger btn-sm" (click)="remove(row)"
                    data-toggle="modal" data-target="#confirmDeleteDialog">
                    <i class="fa fa-trash-o" aria-hidden="true"></i>
                  </button>

                  <button type="button" *ngIf="isCurrentEdit(row)" class="btn btn-danger btn-sm" (click)="cancel(row)">
                    <i class="fa fa-times" aria-hidden="true"></i>
                  </button>

                  <button type="button" *ngIf="isCurrentEdit(row)" class="btn btn-success btn-sm" (click)="save(row)"
                    [disabled]="this.canSave(row)">
                    <i class="fa fa-floppy-o" aria-hidden="true"></i>
                  </button>
                </div>
              </span>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="col-12">
        <div class="alert alert-warning text-dark" role="alert">
          Note:There should be no missing data in table before submitting the data.
        </div>
      </div>

    </div>
    <div *ngIf="this.deleteDataDialog.show">
      <app-confirm-dialog (confirmAction)="this.deleteDialogAction($event)" 
        [data]="this.deleteDataDialog.data">
      </app-confirm-dialog>
    </div>
  </div>
</div>